import styled from "styled-components";

export const Container = styled.div`
  .hidden {
    @media (max-width: 767px) {
      display: none;
    }
  }

  @media (max-width: 767px) {
    color: ${(props) => props.theme.colors.brand1.pure};
    background-color: ${(props) => props.theme.colors.typography2.dark};
    position: fixed;
    bottom: 0;
    padding: 20px 20px 40px;
    width: 100%;
    border-radius: 10px 10px 0 0;
  }
  .close {
    cursor: pointer;
    line-height: 25px;
    margin-left: 95%;
    margin-bottom: 10px;
    @media (min-width: 768px) {
      display: none;
    }
  }
`;

export const WishlistInformationsSettings = styled.div`
  @media (min-width: 768px) {
    display: grid;
    gap: 12px;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: transparent;
    border-radius: 16px;
    border: none;
    font-weight: 550;
    font-size: 0.8rem;
    text-transform: uppercase;
    width: 100%;

    margin: 12px 0;

    @media (min-width: 480px) {
      height: 80px;
      font-size: 1.5rem;
      line-height: 30px;
    }

    @media (min-width: 768px) {
      height: 40px;
      font-size: 0.6rem;
      line-height: 15px;
      padding: 16px 10px;
      width: 50%;
      margin: 0;
    }

    :disabled {
      cursor: not-allowed;
    }

    > svg {
      width: 20px;
      height: 20px;
      margin-right: 6px;

      @media (min-width: 480px) {
        width: 32px;
        height: 32px;
      }

      @media (min-width: 768px) {
        width: 20px;
        height: 20px;
      }
    }
  }

  .btn__edit {
    border: 1px solid ${(props) => props.theme.colors.brand1.pure};
    color: ${(props) => props.theme.colors.brand1.pure};
    width: 100%;
  }

  .btn__products {
    border: 1px solid ${(props) => props.theme.colors.brand1.pure};
    color: ${(props) => props.theme.colors.brand1.pure};
    width: 100%;
    grid-column-end: 3;
    grid-column-start: 1;
  }

  .btn__delete {
    border: 1px solid ${(props) => props.theme.colors.error.pure};
    color: ${(props) => props.theme.colors.error.pure};
    width: 100%;
  }
`;
